import { ExplainerSection, HeroSection } from './sections';

export const ManifestoRoute = () => (
  <>
    <HeroSection />
    <ExplainerSection />
  </>
);
